import { computed, ref } from 'vue';
import { useStore } from '@/store/index'
import FuncoesHelper from '@/helpers/FuncoesHelper';

class ModulosService {
    setup() {
        const store = useStore()
        const modulos = computed(() => store.state.modulos)
        const identificador = ref(FuncoesHelper.obterParametrosRota('identificador'))

        modulos.value.map(module => {
            if (module.recebimentoFinalizado == 'S' && !module.dataHorarioFinalizacao) {
                module.dataHorarioFinalizacao = new Date().toLocaleString('pt-BR')
            }
        })

        setInterval(() => {
            const pdfPendente = modulos.value.find(module => module.recebimentoFinalizado == 'S' && (module.pdfModulo == '' || module.pdfModulo == null))
            if (pdfPendente) {
                location.reload()
            }
        }, 15000)

        return { modulos, identificador }
    }
}

export default new ModulosService()